import { render, staticRenderFns } from "./role-select.vue?vue&type=template&id=e9d3e876&scoped=true&"
import script from "./role-select.vue?vue&type=script&lang=js&"
export * from "./role-select.vue?vue&type=script&lang=js&"
import style0 from "./role-select.vue?vue&type=style&index=0&id=e9d3e876&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9d3e876",
  null
  
)

export default component.exports